import React from "react";
import { Col } from "antd";
import { ProspectTitle, List } from "./utils";

export default function ProspectList({ active, handleProspectChange, data }) {
  return (
    <Col span={24}>
      <ProspectTitle data={data} />
      <List active={active} handleProspectChange={handleProspectChange} data={data} />
    </Col>
  );
}
